/**
 * Product-gallery click fallback.
 *
 * Shopify's thumbnail controls normally use the theme's declarative
 * `on:click` handler. This listener keeps the gallery interactive if that
 * handler is delayed or lost after a Theme Editor section reload.
 */
(() => {
  const thumbnailSelector =
    'media-gallery slideshow-controls[thumbnails] .slideshow-controls__thumbnail';

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const thumbnail = target.closest(thumbnailSelector);
    if (!(thumbnail instanceof HTMLButtonElement)) return;

    const slideshow = thumbnail.closest('slideshow-component');
    if (!slideshow) return;

    const thumbnails = Array.from(
      slideshow.querySelectorAll(
        'slideshow-controls[thumbnails] .slideshow-controls__thumbnail'
      )
    );
    const index = thumbnails.indexOf(thumbnail);
    if (index < 0) return;

    if (typeof slideshow.select === 'function') {
      slideshow.select(index, event, { animate: false });
      return;
    }

    const slides = slideshow.querySelectorAll(
      'slideshow-slides > slideshow-slide'
    );
    const selectedSlide = slides[index];
    if (!selectedSlide) return;

    selectedSlide.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start',
    });

    thumbnails.forEach((item, itemIndex) => {
      if (itemIndex === index) {
        item.setAttribute('aria-selected', 'true');
      } else {
        item.removeAttribute('aria-selected');
      }
    });
  });
})();
